const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the accept invite Directive which defines the sign in form behavior and markup
 * @argument {authorization} AuthorizationResource injected to access the authorization resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('registerWithUserid', ['RegisterWithUserid', 'Application', 'Authorization', 'Analyze', 'AuthorizationResource', '$translate', 'Companies', function(RegisterWithUserid, Application, Authorization, Analyze, AuthorizationResource, $translate, Companies) {
    return {
      restrict: 'E',
      template: require('../../../templates/directives/preauth/register-with-userid.html'),
      controller: function() {
        var self = this;
        var params = Application.navigation.getUrlParameters();
        var url = Application.navigation.getUrl();
        self.passwordConfirm = '';

        self.displaySuccess = false;
        self.credentials = {
          password: ''
        };

        self.loading = false;

        self.register = function() {
          if (!self.credentials.userid || !self.credentials.password) {
            console.log('missing information');
            return;
          }
          var domain = Application.companyDomain;
          self.credentials.domain = domain;
          self.loading = true;
          RegisterWithUserid.register({
            domain: domain,
            authtoken: 'public'
          }, self.credentials, function(data) {
            var login = {domain: Application.navigation.getHost(), userid: self.credentials.userid, password: self.credentials.password};
            AuthorizationResource.signin({}, login, async function(data) {
              if (Authorization.validateAndUseAuthToken(data)) {
                self.loading = false;
                Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
                Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
                Application.analyticsProvider.trackEvent('signin');
                Application.navigation.goToHome();
              }
            }, function(error) {
              self.loading = false;
              Authorization.clearAuthToken();
              console.log('Error', error);
              Application.notifications.setError(self.translations['modules.notifications.invalidCode']);
            });
          }, function(error) {
            self.loading = false;
            Authorization.clearAuthToken();
            console.log('Error', error);
            Application.notifications.setError(self.translations['modules.notifications.invalidCode']);
          });
        };
        self.initialize = function() {
          var domain = Application.companyDomain;
          self.loading = true;
          Companies.checkAlternativeLogins({domain: domain, authtoken: 'public'}).$promise
              .then(function(results) {
                if (results.suspended) {
                  window.location.assign(window.location.origin + '/suspended');
                  return;
                }

                self.useridOption = results.signin_userid;
                self.useridLimit = results.signin_userid_limit;
                self.useridPattern = results.signin_userid_pattern;
                self.useridCopy = results.signin_userid_copy;

                self.companyChecked = true;
                self.loading = false;
                if (!self.useridOption) {
                  return Application.navigation.goToSignIn();
                }
              }).catch(function(error) {
            console.log('error: ', error);
          });
        };
        $translate([
          'modules.notifications.invalidCredentials',
          'modules.notifications.invalidCode',
          'preauth.acceptinvite.passwords_dont_match'
        ]).then(function(data) {
          self.translations = data;
          self.initialize();
        });

      },
      controllerAs: 'registerwithuserid'
    };
  }]);
